import { get, getDataByParams, post, postDataIcon } from "../config/Method";
export const getData = async (data, panel) => {
  let key = "?";
  if (data) {
    for (let i in data) {
      key += "&" + i + "=" + data[i];
    }
  }
  return await get(`/${panel}`, key)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err;
    });
};

export const getByParams = async (data, panel) => {
  return await getDataByParams(`/${panel}`, data)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err;
    });
};
//data : object
//data1 : array
//panel : path api
//file : single file
//file1 : array file
//deleted : array id
export const postData = async (data, data1, panel, file, file1, deleted) => {
  return await post(`/${panel}`, data, data1, file, file1, deleted)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err;
    });
};

export const postWithIcon = async (data, data1, panel, icon, iconActive) => {
  return await postDataIcon(`/${panel}`, data, data1, icon, iconActive)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err;
    });
};
